export default {
  name: 'ContactForm',
  props: {
    componentClass: {type: String, default: ''}
  },
  components: {},
  data: function () {
    return {
      showForms: true,
      mailOptions: [
        {
          title: '',
          value: 0
        },
        {
          title: 'Work at TMG',
          value: 1
        },
        {
          title: 'Work with TMG',
          value: 2
        }
      ],
      status: '',
      activeOption: 0
    }
  },
  methods: {
    onClickOptionTitle: function (event, force) {
      if (this.optionsListElem) {
        if (force) {
          this.optionsListElem.classList.toggle('open', !force)
        } else {
          this.optionsListElem.classList.toggle('open')
        }
      }
    },
    onClickMailOption: function (event) {
      event.stopPropagation()
      let value = Number(event.target.dataset.value)
      this.activeOption = value || 0
      this.onClickOptionTitle(null, true)
    },
    appendForm: function (selector, formId) {
      let formScript = document.createElement('script')
      formScript.text = 'hbspt.forms.create({portalId: "7235140",formId: "' + formId + '"});'
      this.$el.querySelector(selector).appendChild(formScript)
    }
  },
  mounted () {
    this.optionsListElem = this.$el.querySelector('.form-mail-options')

    this.appendForm('#simpleForm', 'ce52c851-5196-4840-b6eb-1067c4c4d782')
    this.appendForm('#workAtForm', '0ab80df3-39a5-43c7-8ee8-ff5d1434c57c')
    this.appendForm('#workWithForm', '92ce7b3f-acab-4d4e-aac0-d0a9e3cbe24e')
  },
  computed: {
    className: function () {
      return `${this.componentClass}`
    }
  },
  watch: {
    '$route.params.activeOptionWorkAt': function (activeOptionWorkAt) {
      if (activeOptionWorkAt) {
        this.activeOption = activeOptionWorkAt
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ContactForm/ContactForm.js